export default function (state, val) {
    let filter = state.filters.filter(i => {
        return i.id === val.id;
    })[0];
    for (let k in val) {
        switch (k) {
            case 'Contragent':
                filter.ContragentId = val.value ? val.value : '';
                filter.ContragentName = val.label ? val.label : '';
                break;
            default:
                if (typeof filter[k] !== 'undefined') filter[k] = val[k];
        }
    }
}